// extracted by mini-css-extract-plugin
module.exports = {"container":"Collapsable_container__3yksG","title":"Collapsable_title__3aKDL","collapsed":"Collapsable_collapsed__2adVV","uncollapsed":"Collapsable_uncollapsed__2ihT4"};